<template>
  <div class="wj_box">
    <div class="wj_header">
      <el-row>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 22, offset: 1 }"
          :md="{ span: 16, offset: 4 }"
          :lg="{ span: 14, offset: 5 }"
          :xl="{ span: 14, offset: 5 }"
          class="wj_header_main"
        >
          <div class="wj_header_left">
            <img
              alt="投票、企业投票云服务、企业投票、网络投票、微信投票、会议投票"
              src="../../../assets/images/logo2_1.png"
            />
          </div>
          <el-link
            class="wj_header_right_link"
            @click="userOut()"
            v-if="backTarget === 'signin'"
          >
            <i class="el-icon-switch-button"></i>
            <span>退出</span>
          </el-link>
          <el-link
            class="wj_header_right_link"
            @click="backList()"
            v-if="backTarget === 'list'"
          >
            <span>返回列表</span>
          </el-link>
        </el-col>
      </el-row>
    </div>
    <el-row class="wj_main">
      <el-col
        :xs="{ span: 24 }"
        :sm="{ span: 22, offset: 1 }"
        :md="{ span: 16, offset: 4 }"
        :lg="{ span: 14, offset: 5 }"
        :xl="{ span: 14, offset: 5 }"
      >
        <div class="wj_body" v-if="answerPaper.State === 1">
          <div class="wj_body_head">
            <h1>{{ answerPaper.QuestionnaireName }}</h1>
          </div>
          <div class="wj_body_head_secondary" v-if="answerPaper.WelcomeWord">
            {{ answerPaper.WelcomeWord }}
          </div>
          <div class="wj_body_head_info">
            <div class="wj_body_head_info_left">
              <span class="wj_body_head_info_left_item">
                题目数量：{{ answerPaper.QuestinsNumber }}
              </span>
              <span
                v-if="answerPaper.QuestionnaireType === 1"
                class="wj_body_head_info_left_item"
              >
                总分：{{ answerPaper.TotalScore }}分
              </span>
              <span
                v-if="
                  answerPaper.QuestionnaireType === 1 &&
                  answerPaper.IsSetPassScore
                "
                class="wj_body_head_info_left_item"
              >
                通过线：{{ answerPaper.PassScore }}分
              </span>
            </div>
            <div
              class="wj_body_head_info_right"
              v-if="answerPaper.QuestionnaireType === 1"
            >
              <span class="wj_body_head_info_right_item">
                开始时间：
                {{ answerPaper.StartTime | dateformat('YYYY-MM-DD HH:mm') }}
              </span>
              <span
                class="wj_body_head_info_right_item"
                v-if="answerPaper.TimeState === 1"
              >
                未到开始时间
              </span>
              <span
                class="wj_body_head_info_right_item"
                v-if="answerPaper.TimeState === 2"
              >
                <i
                  class="el-icon-timer"
                  style="font-size: 26px; margin-right: 5px"
                ></i>
                <FlipDown
                  :endDate="answerPaper.EndTime"
                  @timeUp="timeOut"
                  :type="3"
                  :theme="1"
                  :timeUnit="[':', ':', ':']"
                  class="flip-down"
                />
              </span>
              <span
                class="wj_body_head_info_right_item"
                v-if="answerPaper.TimeState === 3"
              >
                已过答题时间
              </span>
            </div>
          </div>
          <div
            class="wj_element_box"
            v-for="(element, index) in answerPaper.ElementItems"
            :key="index"
          >
            <div
              class="wj_element"
              :style="[
                {
                  border: element.NoAnswer
                    ? '2px solid #E6A23C'
                    : '2px solid #fff'
                }
              ]"
            >
              <div
                class="wj_element_title_all wj_element_title_duanluo"
                v-if="element.ElementType === 1 && !element.IsOnlyManualShow"
              >
                <span class="show_index">{{ element.ShowIndex }}、</span>
                <div class="wj_element_title" v-html="element.Title"></div>
              </div>

              <div
                class="wj_element_title_all wj_element_title_question_16"
                v-if="element.ElementType === 2 && element.QuestionType !== 4"
              >
                <span class="show_index">{{ element.ShowIndex }}.</span>
                <div
                  class="wj_element_title"
                  v-html="
                    '<span class=\'element_type\'>【' +
                    element.QuestionTypeText +
                    '】</span>' +
                    element.QuestionStem
                  "
                >
                  <!-- <div v-html="element.QuestionStem"></div>
                  <span class="element_type" v-if="element.QuestionTypeText">
                    【{{ element.QuestionTypeText }}】
                  </span>
                  <span
                    class="element_score"
                    v-if="answerPaper.QuestionnaireType === 1"
                    v-show="false"
                  >
                    （{{ element.QuestionScore }}分）
                  </span> -->
                </div>
                <!-- <div
                  class="wj_element_title"
                  v-html="
                    '<span class=\'element_score\'>（' +
                    element.QuestionScore +
                    '分）</span>' +
                    '<span class=\'element_type\'>【' +
                    element.QuestionTypeText +
                    '】</span>' +
                    element.QuestionStem
                  "
                >
                </div> -->
              </div>

              <div
                class="wj_element_title_all wj_element_title_question_16"
                v-if="element.ElementType === 2 && element.QuestionType === 4"
                @click="blankFocus(element)"
              >
                <span class="show_index">{{ element.ShowIndex }}.</span>
                <div
                  class="wj_element_title"
                  v-html="
                    '<span class=\'element_type\'>【' +
                    element.QuestionTypeText +
                    '】</span>' +
                    getBlankBody(element, index)
                  "
                ></div>
                <!-- <div class="wj_element_title">
                  <div
                    class="questionStem"
                    v-html="getBlankBody(element, index)"
                  ></div>
                  <span class="element_type" v-if="element.QuestionTypeText">
                    【{{ element.QuestionTypeText }}】
                  </span>
                  <span
                    class="element_score"
                    v-if="answerPaper.QuestionnaireType === 1"
                    v-show="false"
                  >
                    （{{ element.QuestionScore }}分）
                  </span>
                </div> -->
              </div>

              <div
                class="wj_element_option_box"
                v-if="element.QuestionType === 1 || element.QuestionType === 3"
              >
                <div
                  class="wj_element_option_item"
                  v-for="(optionItem, optionIndex) in element.OptionItems"
                  :key="optionIndex"
                >
                  <el-radio
                    v-model="element.SelectOptionId"
                    :label="optionItem.AnswerPaperOptionId"
                    class="choice"
                    @change="optionRadioChange(element)"
                  >
                    <div class="choice_inner">
                      <span class="choice_index">{{
                        getOptionIndex(
                          answerPaper.OptionSerialNumberType,
                          optionIndex
                        )
                      }}</span>
                      <div
                        class="choice_content"
                        v-html="optionItem.Content"
                      ></div>
                    </div>
                  </el-radio>
                </div>
              </div>

              <div
                class="wj_element_option_box"
                v-if="element.QuestionType === 2"
              >
                <div
                  class="wj_element_option_item"
                  v-for="(optionItem, optionIndex) in element.OptionItems"
                  :key="optionIndex"
                >
                  <el-checkbox
                    v-model="optionItem.Selected"
                    class="choice"
                    @change="optionCheckChange(element)"
                  >
                    <div class="choice_inner">
                      <span class="choice_index">{{
                        getOptionIndex(
                          answerPaper.OptionSerialNumberType,
                          optionIndex
                        )
                      }}</span>
                      <div
                        class="choice_content"
                        v-html="optionItem.Content"
                      ></div>
                    </div>
                  </el-checkbox>
                </div>
              </div>

              <div v-if="element.QuestionType === 5">
                <el-input
                  type="textarea"
                  :rows="element.TextHeight"
                  :minlength="element.MinWordNum"
                  :maxlength="element.MaxWordNum"
                  :style="[
                    {
                      width:
                        element.TextWidth == 0
                          ? '100%'
                          : element.TextWidth + 'px'
                    }
                  ]"
                  v-model="element.AnswerElementAnswer"
                  @focus="qaFocus(element)"
                >
                </el-input>
              </div>
            </div>
          </div>
        </div>
        <div class="wj_body" v-if="answerPaper.State !== 1">
          <el-empty :description="answerPaper.StrState"></el-empty>
        </div>
      </el-col>
    </el-row>
    <el-row class="wj_footer">
      <el-col
        :xs="{ span: 24 }"
        :sm="{ span: 22, offset: 1 }"
        :md="{ span: 16, offset: 4 }"
        :lg="{ span: 14, offset: 5 }"
        :xl="{ span: 14, offset: 5 }"
      >
        <div class="wj_footer_box">
          <div class="hidden-xs-only">
            北京鹏宇成软件技术有限公司 提供技术支持
          </div>
          <div>
            <el-button
              type="primary"
              style="width: 100px; letter-spacing: 10px; text-indent: 10px"
              @click="saveAnswerPaper()"
              v-if="
                answerPaper.State === 1 &&
                !answerPaper.IsSubmit &&
                (answerPaper.TimeState === 0 || answerPaper.TimeState === 2)
              "
            >
              保存
            </el-button>
            <el-button
              type="primary"
              style="width: 100px; letter-spacing: 10px; text-indent: 10px"
              @click="submitAnswerPaper()"
              v-if="
                answerPaper.State === 1 &&
                !answerPaper.IsSubmit &&
                (answerPaper.TimeState === 0 || answerPaper.TimeState === 2)
              "
            >
              提交
            </el-button>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import answerPaperApi from '../../../api/wj/answerPaper'
import FlipDown from '@/components/FlipDown.vue'
export default {
  components: {
    FlipDown
  },
  data () {
    return {
      answerPaper: {},
      backTarget: 'list',
      answerPaperForm: {},
      tempElementItems: [],
      noAnswerList: []
    }
  },
  methods: {
    userOut: function () {
      this.$confirm('确定退出吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'wj_message_box'
      }).then(() => {
        this.$store.commit('REMOVE_ACCOUNT')
        this.$router.push({ name: 'answerLogin', params: { cid: this.$route.params.cid, mid: this.$route.params.mid, qid: this.$route.params.qid } })
      }).catch(() => {

      })
    },
    backList: function () {
      this.$router.push({ name: 'answerQuestionnaireList', params: { mid: this.$route.params.mid } })
    },
    getAnswerPaper: function () {
      const _this = this
      _this.openLoading()
      answerPaperApi.getCurrentUserAnswerPaper({
        QuestionnaireId: _this.$route.params.qid,
        AnswerPaperId: _this.$route.params.aid
      }).then(data => {
        _this.answerPaper = data
        _this.answerPaper.EndTime = new Date(this.$moment(_this.answerPaper.EndTime).format('yyyy-MM-DD HH:mm'))
        _this.answerPaper.CurrentTime = new Date(this.$moment(_this.answerPaper.CurrentTime).format('yyyy-MM-DD HH:mm'))
        if (_this.answerPaper.IsSubmit) {
          _this.$router.push({ name: 'completeAnswerPaper', params: { cid: _this.$route.params.cid, mid: _this.$route.params.mid, qid: _this.$route.params.qid, aid: _this.$route.params.aid, s: _this.$route.params.s } })
        }
        if (_this.answerPaper.TimeState === 1) {
          _this.$confirm('未到开始时间，请在规定时间填写问卷！', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            showClose: false,
            showCancelButton: false,
            closeOnClickModal: false
          }).then(() => {
            _this.$router.push({ name: 'answerQuestionnaireList', params: { mid: this.$route.params.mid } })
          }).catch(() => {
            _this.$router.push({ name: 'answerQuestionnaireList', params: { mid: this.$route.params.mid } })
          })
        }
        if (_this.answerPaper.TimeState === 3) {
          _this.$confirm('已过答卷时限，是否提交问卷！', '提示', {
            confirmButtonText: '提交',
            cancelButtonText: '取消',
            type: 'warning',
            showClose: false,
            closeOnClickModal: false
          }).then(() => {
            _this.validateAnswerPaperForm('submit')
            _this.openLoading()
            _this.setAnswerPaperForm('submit')
            _this.editAnswerPaper('submit')
          }).catch(() => {
            _this.$router.push({ name: 'answerQuestionnaireList', params: { mid: this.$route.params.mid } })
          })
        }
        _this.openLoading().close()
      }).catch(err => {
        _this.openLoading().close()
        return err
      })
    },
    getOptionIndex: function (optionSerialNumberType, optionIndex) {
      if (optionSerialNumberType === 2) {
        return String.fromCharCode(65 + optionIndex) + '、'
      } else if (optionSerialNumberType === 3) {
        return String.fromCharCode(65 + optionIndex).toLowerCase() + '、'
      } else {
        return optionIndex + 1 + '、'
      }
    },
    getBlankBody1: function (element) {
      //   const questionStem = ''
      let questionStem = JSON.parse(JSON.stringify(element.QuestionStem))
      questionStem = questionStem.replace(/<p>/g, '')
      questionStem = questionStem.replace(/<\/p>/g, '')
      const stemArray = questionStem.split('___')

      const blankItems = []
      stemArray.forEach(function (item, index) {
        if (item !== '') {
          blankItems.push(item)
        }
      })
      return blankItems
    },
    getBlankBody: function (element, elementIndex) {
      let questionStem = ''
      const stemArray = element.QuestionStem.split('___')

      let optionIndex = 0
      stemArray.forEach(function (item, index) {
        if (item !== '') {
          questionStem = questionStem + item
          if (index < stemArray.length - 1) {
            let blankItemTextWidth = element.OptionItems[optionIndex].TextWidth + 'px'
            if (element.OptionItems[optionIndex].TextWidth === 0) {
              blankItemTextWidth = '100%'
            }
            const blankItemAnswer = element.OptionItems[optionIndex].Answer
            questionStem = questionStem + '<input type="text" id="' + element.AnswerPaperElementId.toLowerCase() + '_' + element.OptionItems[optionIndex].AnswerPaperOptionId.toLowerCase() + '" class="blankInput" style="width:' + blankItemTextWidth + '" value="' + blankItemAnswer + '" maxlength="' + element.OptionItems[optionIndex].MaxWordNum + '" minlength="' + element.OptionItems[optionIndex].MinWordNum + '"  />'
            optionIndex++
          }
        }
      })
      return questionStem
    },
    saveAnswerPaper: function () {
      const _this = this
      _this.openLoading()
      _this.validateAnswerPaperForm('all_save')
      _this.setAnswerPaperForm('all_save')
      _this.editAnswerPaper('all_save')
    },
    submitAnswerPaper: function () {
      const _this = this
      _this.validateAnswerPaperForm('submit')
      if (_this.noAnswerList.length > 0) {
        _this.$confirm('有未回答的问题，请检查确认是否提交？', '提示', {
          confirmButtonText: '确定提交',
          cancelButtonText: '继续填写',
          customClass: 'wj_message_box',
          type: 'warning'
        }).then(() => {
          _this.openLoading()
          _this.setAnswerPaperForm('submit')
          _this.editAnswerPaper('submit')
        }).catch((err) => {
          return err
        })
      } else {
        _this.$confirm('确定提交吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          customClass: 'wj_message_box'
        }).then(() => {
          _this.openLoading()
          _this.setAnswerPaperForm('submit')
          _this.editAnswerPaper('submit')
        }).catch((err) => {
          return err
        })
      }
    },
    editAnswerPaper: function (action) {
      const _this = this
      answerPaperApi.saveAnswerPaper(_this.answerPaperForm).then(data => {
        if (action === 'submit') {
          _this.$message({
            showClose: true,
            type: 'success',
            message: '提交成功！',
            customClass: 'custom_message'
          })
          _this.openLoading().close()
          _this.$router.push({ name: 'completeAnswerPaper', params: { cid: _this.$route.params.cid, mid: _this.$route.params.mid, qid: _this.$route.params.qid, aid: _this.$route.params.aid, s: _this.$route.params.s } })
        }
        if (action === 'all_save') {
          _this.getAnswerPaper()
          _this.$message({
            showClose: true,
            type: 'success',
            message: '保存成功！',
            customClass: 'custom_message'
          })
        }
      }).catch(err => {
        _this.openLoading().close()
        return err
      })
    },
    validateAnswerPaperForm: function (action) {
      const _this = this
      _this.openLoading()
      _this.noAnswerList = []
      _this.tempElementItems = []
      _this.answerPaper.ElementItems.forEach(function (elementItem, elementItemIndex) {
        if (elementItem.ElementType === 2) {
          const tempElementItem = {}
          switch (elementItem.QuestionType) {
            case 1: {
              if (!elementItem.SelectOptionId && action === 'submit') {
                _this.$set(elementItem, 'NoAnswer', true)
                _this.noAnswerList.push(elementItem.AnswerPaperOptionId)
              }
              tempElementItem.AnswerPaperElementId = elementItem.AnswerPaperElementId
              tempElementItem.OptionItems = []
              elementItem.OptionItems.forEach(function (optionItem, optionItemIndex) {
                let optionSelected = false
                if (elementItem.SelectOptionId) {
                  if (optionItem.AnswerPaperOptionId.toLowerCase() === elementItem.SelectOptionId.toLowerCase()) {
                    optionSelected = true
                  }
                }
                tempElementItem.OptionItems.push(
                  {
                    AnswerPaperOptionId: optionItem.AnswerPaperOptionId,
                    Answer: '',
                    Selected: optionSelected
                  }
                )
              })
              _this.tempElementItems.push(tempElementItem)
              break
            }
            case 2: {
              tempElementItem.AnswerPaperElementId = elementItem.AnswerPaperElementId
              tempElementItem.OptionItems = []
              let selectedNum = 0
              elementItem.OptionItems.forEach(function (optionItem, optionItemIndex) {
                let optionSelected = false
                if (optionItem.Selected) {
                  optionSelected = true
                  selectedNum++
                }
                tempElementItem.OptionItems.push(
                  {
                    AnswerPaperOptionId: optionItem.AnswerPaperOptionId,
                    Answer: '',
                    Selected: optionSelected
                  }
                )
              })
              _this.tempElementItems.push(tempElementItem)
              if (selectedNum === 0 && action === 'submit') {
                _this.$set(elementItem, 'NoAnswer', true)
                _this.noAnswerList.push(elementItem.AnswerPaperOptionId)
              }
              break
            }
            case 3:
              if (!elementItem.SelectOptionId && action === 'submit') {
                _this.$set(elementItem, 'NoAnswer', true)
                _this.noAnswerList.push(elementItem.AnswerPaperOptionId)
              }
              tempElementItem.AnswerPaperElementId = elementItem.AnswerPaperElementId
              tempElementItem.OptionItems = []
              elementItem.OptionItems.forEach(function (optionItem, optionItemIndex) {
                let optionSelected = false
                if (elementItem.SelectOptionId) {
                  if (optionItem.AnswerPaperOptionId.toLowerCase() === elementItem.SelectOptionId.toLowerCase()) {
                    optionSelected = true
                  }
                }
                tempElementItem.OptionItems.push(
                  {
                    AnswerPaperOptionId: optionItem.AnswerPaperOptionId,
                    Answer: '',
                    Selected: optionSelected
                  }
                )
              })
              _this.tempElementItems.push(tempElementItem)
              break
            case 4: {
              tempElementItem.AnswerPaperElementId = elementItem.AnswerPaperElementId
              tempElementItem.OptionItems = []
              let emptyNum = 0
              elementItem.OptionItems.forEach(function (optionItem, optionItemIndex) {
                const optionItemInput = document.getElementById(elementItem.AnswerPaperElementId + '_' + optionItem.AnswerPaperOptionId)
                if (!optionItemInput.value) {
                  emptyNum++
                }
                tempElementItem.OptionItems.push(
                  {
                    AnswerPaperOptionId: optionItem.AnswerPaperOptionId,
                    Answer: optionItemInput.value ? optionItemInput.value : ''
                  }
                )
              })
              _this.tempElementItems.push(tempElementItem)
              if (emptyNum > 0 && action === 'submit') {
                _this.$set(elementItem, 'NoAnswer', true)
                _this.noAnswerList.push(elementItem.AnswerPaperOptionId)
              }
              break
            }
            case 5: {
              if (!elementItem.AnswerElementAnswer && action === 'submit') {
                _this.$set(elementItem, 'NoAnswer', true)
                _this.noAnswerList.push(elementItem.AnswerPaperOptionId)
              }
              tempElementItem.AnswerPaperElementId = elementItem.AnswerPaperElementId
              if (elementItem.AnswerElementAnswer) {
                tempElementItem.Answer = elementItem.AnswerElementAnswer
              }
              _this.tempElementItems.push(tempElementItem)
              break
            }
          }
        }
      })
      _this.openLoading().close()
    },
    setAnswerPaperForm: function (action) {
      const _this = this
      _this.answerPaperForm = {}
      _this.answerPaperForm.AnswerPaperId = _this.answerPaper.AnswerPaperId
      _this.answerPaperForm.QuestionnaireId = _this.answerPaper.QuestionnaireId
      _this.answerPaperForm.Action = action
      _this.answerPaperForm.ElementItems = _this.tempElementItems
    },
    qaFocus: function (element) {
      const _this = this
      _this.$set(element, 'NoAnswer', false)
    },
    blankFocus (element) {
      const _this = this
      _this.$set(element, 'NoAnswer', false)
    },
    optionRadioChange: function (element) {
      const _this = this
      _this.$set(element, 'NoAnswer', false)
    },
    optionCheckChange: function (element) {
      const _this = this
      _this.$set(element, 'NoAnswer', false)
    },
    timeOut: function () {
      const _this = this
      _this.$confirm('已过答卷时限，是否提交问卷！', '提示', {
        confirmButtonText: '提交',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false,
        closeOnClickModal: false,
        showCancelButton: false
      }).then(() => {
        _this.validateAnswerPaperForm('submit')
        _this.openLoading()
        _this.setAnswerPaperForm('submit')
        _this.editAnswerPaper('submit')
      }).catch(() => {
        _this.$router.push({ name: 'answerQuestionnaireList', params: { mid: this.$route.params.mid } })
      })
    }
  },
  created () {
    this.backTarget = this.$route.params.s
    this.getAnswerPaper()
  }
}
</script>

<style lang="less">
@import '../../../assets/css/wj.css';
</style>
